export default {
  title: 'Metode de comandă',
  paywall: {
    live_title: '{{name}} este live!',
  },
  tabs: {
    general: 'General',
    pickup: 'Ridicare',
    delivery: 'Livrare',
    room_service: 'Serviciu cameră/masă',
  },
  modals: {
    update_confirmation: {
      title: 'Ești sigur că vrei să salvezi modificările?',
      buttons: {
        confirm: 'Confirmă',
        cancel: 'Anulează',
      },
    },
    switch_live_orders: {
      titles: {
        disable: 'Ești sigur că vrei să dezactivezi comenzile live?',
        enable: 'Ești sigur că vrei să activezi comenzile live?',
      },
      buttons: {
        yes: 'Da',
        no: 'Nu',
      },
    },
  },
  toasts: {
    failed_to_save_changes: 'Nu s-au putut salva modificările',
    changes_got_saved: 'Modificările au fost salvate',
  },
};
